// Derived playback status — never stored; Idle = not playing at progress 1.
enum PlaybackStatus {
  Idle,
  Paused,
  Playing,
}

export default PlaybackStatus;
